<template>
  <div>
    <header-main class="anchored"></header-main>
    <nav-mobile></nav-mobile>
    <section id="order-step2" class="order">
		<header class="main">
			<steps :step="3"></steps>
		</header>
		<div class="wrapper">
			<div class="content">
				<section>
					<header>
					<h4>Potwierdź wybraną usługę i swoje dane</h4>
					</header>
					<div class="flex">
					<div class="column">
						<div class="data">
              <div class="warning" v-if="formData.businessType == 'SPÓŁKI CYWILNE PROWADZĄCE DZIAŁALNOŚĆ NA PODSTAWIE UMOWY ZAWARTEJ ZGODNIE Z KODEKSEM CYWILNYM'">
                <h4>UWAGA!</h4>
                <p>W przypadku spółki cywilnej wymagane jest wysłanie skanu umowy spółki na adres: <span>bok@afkcob.pl</span></p>
              </div>
						<header>
							<h6>Dane firmowe</h6>
						</header>
						<div class="container">
							<ul>
							<li><span>NIP:</span> {{ formData.nip }}</li>
							<li><span>Nazwa firmy:</span> {{ formData.companyName }}</li>
							<li><span>Ulica:</span> {{ formData.street }}</li>
							<li><span>Numer lokalu:</span> {{ formData.houseNumber }}</li>
							<li><span>Miejsowość:</span> {{ formData.city }}</li>
							<li><span>Kod pocztowy:</span> {{ formData.postCode }}</li>
							</ul>
						</div>
						</div>
						<div class="data">
						<header>
							<h6>Osoby podpisujące umowę</h6>
						</header>
						<div class="container">
							<ul v-for="(person, index) in formData.contractSigners" :key="'contract' + index">
							<li><span>Imię:</span> {{ person.name }}</li>
							<li><span>Nazwisko:</span> {{ person.surname }}</li>
							<!-- <li><span>Pesel / paszport:</span> {{ person.id }}</li> -->
							<li v-if="person.otherPosition"><span>Stanowisko:</span> {{ person.otherPosition }}</li>
							<li v-if="!person.otherPosition"><span>Stanowisko:</span> {{ person.position }}</li>
							</ul>
						</div>
						</div>
						<div class="data">
              <header>
                <h6>Dane do korespondencji</h6>
              </header>
              <div class="container">
                <ul>
                  <li><span>Miasto:</span> {{ formData.correspondenceAddress.city }}</li>
                  <li><span>Ulica:</span> {{ formData.correspondenceAddress.street }}</li>
                  <li><span>Numer domu/mieszkania:</span> {{ formData.correspondenceAddress.houseNumber }}</li>
                  <li><span>Kod pocztowy:</span> {{ formData.correspondenceAddress.postCode }}</li>
                  <li v-if="formData.correspondenceAddress.comments"><span>Dodatkowe uwagi:</span> {{ formData.correspondenceAddress.comments }}</li>
                </ul>
                <ul>
                  <li v-for="(number, index) in formData.correspondenceNumber" :key="'number' + index">
                    <span>Telefon nr. {{ index + 1 }}:</span> {{ number.number }}
                  </li>
                </ul>
                <ul>
                  <li v-for="(email, index) in formData.correspondenceEmail" :key="'email' + index">
                    <span>Adres email nr. {{ index + 1 }}:</span> {{ email.email }}
                  </li>
                </ul>
              </div>
						</div>
            <div class="data">
              <header>
                <h6>Osoby upoważnione do odbioru korespondencji</h6>
              </header>
              <div class="container">
                <ul v-for="(person, index) in formData.correspondencePeople" :key="'correspondence' + index">
                  <li><span>Imię: </span>{{ person.name }}</li>
                  <li><span>Nazwisko: </span>{{ person.surname }}</li>
                  <li><span>Pesel / paszport: </span>{{ person.id }}</li>
                </ul>
              </div>
            </div>
              <div class="data">
                <header>
                  <h6>Umowa</h6>
                </header>
                <div class="container">
                  <ul v-if="contractSigningMethod == 0">
                    <li><span>Sposób podpisania umowy: </span> W siedzibie AFK</li>
                    <li><p>Skontaktujemy się z Tobą w najbliższym dniu roboczym w celu umówienia spotkania.</p></li>
                    <li><p><i class="material-icons">call</i> +48 71 336 95 21</p></li>
                    <li><p><i class="material-icons">email</i> bok@afkcob.pl</p></li>
                    <li><p><i class="material-icons">place</i> <span>ul. Świeradowska 51-57 , 50-559 Wrocław, I piętro Centrum Handlowe Ferio Gaj</span></p></li>
                    <li><p><i class="material-icons">watch_later</i> poniedziałek – piątek 9:00-17:00</p></li>
                  </ul>
                  <ul v-if="contractSigningMethod == 1">
                    <li><span>Sposób podpisania umowy: </span> Przez kuriera</li>
                    <li><span>Imię: </span>{{ formData.courierData.name }}</li>
                    <li><span>Nazwisko: </span>{{ formData.courierData.surname }}</li>
                    <li><span>Nazwa firmy: </span>{{ formData.courierData.companyName }}</li>
                    <li><span>Telefon: </span>{{ formData.courierData.number }}</li>
                    <li><span>Ulica: </span>{{ formData.courierData.street }}</li>
                    <li><span>Numer domu/mieszkania: </span>{{ formData.courierData.houseNumber }}</li>
                    <li><span>Kod pocztowy: </span>{{ formData.courierData.postCode }}</li>
                    <li><span>Miasto: </span>{{ formData.courierData.city }}</li>
                    <li><span>Uwagi dla kuriera: </span>{{ formData.courierData.comments }}</li>
                  </ul>
                </div>
              </div>
              <div class="second-sticky-container">
                <div class="sticky">
                  <div class="date">
                  <h6>Data rozpoczęcia usługi</h6>
                  <p>{{ dateStart }}</p>
                  </div>
                  <div class="date">
                  <h6>Data zakończenia usługi</h6>
                  <p>{{ dateEnd }}</p>
                  </div>
                  <div class="prices">
                  <div class="price gray">
                    <h5>Netto:</h5>
                    <h6>{{ getNetto() }} zł</h6>
                  </div>
                  <div class="price dark-gray">
                    <h5>Brutto:</h5>
                    <h6>{{ getBrutto() }} zł</h6>
                  </div>
                  </div>
                </div>
              </div>
						<div class="button">
						   <button class="default small" @click="showAgreement()">Zobacz umowę</button>
						</div>
            <div class="input-container">
              <div class="input-checkbox">
                <div class="checkbox" :class="{ error: validateContractAgreementCheck.value == 1 }" @click="checkCheckBox()">
                    <i class="material-icons" v-if="contractAgreementCheck">done</i>
                </div>
                <p>* Akceptuję warunki umowy</p>
              </div>
              <p class="checkbox" v-if="validateContractAgreementCheck.value == 1">{{ validateContractAgreementCheck.text }}</p>
            </div>
					</div>
          <div class="column">
						<div class="user">
							<div class="icon">
							<i class="material-icons">person_outline</i>
							</div>
							<div class="user-data">
							<p>{{ formData.email }}</p>
							</div>
						</div>
						<div class="month">{{ getMonthNumber(monthActiveReal) }} m-c</div>
						<div class="packet mini small" v-if="packetActive == 1">
							<div class="content">
							<div class="icon"></div>
							<h5>Pakiet Mini</h5>
							<h4>{{ prices.mini[monthActiveReal] }} PLN</h4>
							<p>netto | m-c</p>
							</div>
						</div>
						<div class="packet standard small" v-if="packetActive == 2">
							<div class="content">
							<div class="icon"></div>
							<h5>Pakiet Standard</h5>
							<h4>{{ prices.standard[monthActiveReal] }} PLN</h4>
							<p>netto | m-c</p>
							</div>
						</div>
						<div class="packet comfort small" v-if="packetActive == 3">
							<div class="content">
							<div class="icon"></div>
							<h5>Pakiet Komfort</h5>
							<h4>{{ prices.komfort[monthActiveReal] }} PLN</h4>
							<p>netto | m-c</p>
							</div>
						</div>
            <div class="sticky-container">
              <div class="sticky">
                <div class="date">
                <h6>Data rozpoczęcia usługi</h6>
                <p>{{ dateStart }}</p>
                </div>
                <div class="date">
                <h6>Data zakończenia usługi</h6>
                <p>{{ dateEnd }}</p>
                </div>
                <div class="prices">
                <div class="price gray">
                  <h5>Usługa najmu netto:</h5>
                  <h6>{{ getNetto() }} zł</h6>
                </div>
                <div class="price gray" v-if="activationFee && activationFee != 0">
                  <h5>Opłata aktywacyjna netto:</h5>
                  <h6>{{ getActivationFee() }} zł</h6>
                </div>
                <div class="price gray" v-if="activationFee && activationFee != 0">
                  <h5>Razem netto:</h5>
                  <h6>{{ getNettoSum() }} zł</h6>
                </div>
                <div class="price dark-gray">
                  <h5>Do zapłaty brutto:</h5>
                  <h6>{{ getBrutto()}} zł</h6>
                </div>
                </div>
              </div>
            </div>
					</div>
					</div>
				</section>
			</div>
			<order-nav forwardString="Zapłać" backPath="/zamowienie/krok/2" forwardPath="" @order="order"></order-nav>
		</div>
    </section>
    <agreement></agreement>
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import NavMobile from '@/components/NavMobile.vue'
import FooterMain from '@/components/FooterMain.vue'
import OrderNav from '@/components/OrderNav.vue'
import Steps from '@/components/Steps.vue'
import Agreement from '@/components/Agreement.vue'

export default {
  name: 'step3',
  components: {
    HeaderMain,
    NavMobile,
    FooterMain,
    OrderNav,
    Steps,
    Agreement
  },
  data() {

    return {
      contractSigningMethod: '',
      monthActiveReal: -1,
      packetActiveReal: -1,
      dateStart: '',
      dateEnd: '',
      formData: {},
      contractSeen: 0,
      contractAgreementCheck: 0,
      validateContractAgreementCheck: { value: 0, text: '' },
      validateContractAgreementTexts: ['Pole wymaga zaznaczenia', 'Kliknij przycisk "Zobacz umowę" i zapoznaj się z umową'],
    }
  },
  computed: {
    monthActive(){
      return this.$store.state.monthActive;
    },
    prices(){
      return this.$store.state.prices;
    },
    packetActive(){
      return this.$store.state.packetActive;
    },
    api(){
      return this.$store.state.api;
    },
    activationFee() {
      return localStorage.activationFee;
    },
  },
  created(){
    this.getMonth();
    this.getPacket();
    this.checkDatesValidity();
    this.formatDates();
    this.getFormData();
    this.getStep2State();
  },
  methods:{
    checkCheckBox() {
      if(this.contractSeen == 1 && this.contractAgreementCheck == 0) {
        this.contractAgreementCheck = 1;
        if(this.validateContractAgreementCheck.text == this.validateContractAgreementTexts[0]) {
          this.validateContractAgreementCheck.value = 0;
        }
      } else if(this.contractAgreementCheck == 1) {
        this.contractAgreementCheck = 0;
      } else {
        this.validateContractAgreementCheck.value = 1;
        this.validateContractAgreementCheck.text = this.validateContractAgreementTexts[1];
      }
    },
    checkDatesValidity() {
      const days = 30;
      const months = this.getMonthNumber(this.monthActiveReal);
      let dateStart = new Date(localStorage.dateStart);
      let date = new Date(dateStart);
      let dateEnd;
      const today = new Date();
      if(dateStart.getTime() < today.getTime()) {
        dateStart = today;
      }
      if(dateStart.getDate() == 1){
        dateEnd = date.setMonth(date.getMonth() + months);
      } else {
        dateEnd = dateStart.getTime() + (days * months * 86400000);
      }
      localStorage.dateStart = dateStart;
      localStorage.dateEnd = new Date(dateEnd);
    },
    getMonth(){
      if(typeof localStorage.period == 'undefined'){
        this.monthActiveReal = this.monthActive;
      }else{
        this.monthActiveReal = localStorage.period;
      }
    },
    getPacket(){
      if(typeof localStorage.packet == 'undefined'){
        this.packetActiveReal = this.packetActive;
      }else{
        this.packetActiveReal = localStorage.packet;
      }
    },
    getMonthNumber(id){
      switch(parseInt(id)){
        case 0:
          return 3;
        break;
        case 1:
          return 6;
        break;
        case 2:
          return 12;
        break;
        default:
          return 3
        break;
      }
    },
    formatDates(){
      let dateStart = new Date(localStorage.dateStart);
      let dateEnd =  new Date(localStorage.dateEnd);
      let chosenDays = dateStart.getDate();
      if(chosenDays < 10){
        chosenDays = '0' + chosenDays;
      }
      let chosenMonths = dateStart.getMonth() + 1;
      if(chosenMonths < 10){
        chosenMonths = '0' + chosenMonths
      }
      let endDays = dateEnd.getDate();
      if(endDays < 10){
        endDays = '0' + endDays;
      }
      let endMonths = dateEnd.getMonth() + 1;
      if(endMonths < 10){
        endMonths = '0' + endMonths;
      }
      this.dateStart = dateStart.getFullYear() + '-' + chosenMonths + '-' + chosenDays;
      this.dateEnd = dateEnd.getFullYear() + '-' + endMonths + '-' + endDays;
    },
    getNetto(){
      let period = this.getMonthNumber(this.monthActiveReal);
      let price = 0;
      if(this.packetActiveReal == 1){
        price = this.prices.mini[this.monthActiveReal];
      }else if(this.packetActiveReal == 2){
        price = this.prices.standard[this.monthActiveReal];
      }else{
        price = this.prices.komfort[this.monthActiveReal];
      }
      price = parseFloat(price) * period;
      price = price.toFixed(2);
      price = price.replace('.', ',');
      let formData = JSON.parse(localStorage.formData);
      formData.priceNetto = price;
      localStorage.setItem('formData', JSON.stringify(formData));
      return price;
    },
    getNettoSum() {
      let netto = this.getNetto();
      netto = netto.replace(',', '.');
      let fee = this.getActivationFee();
      if(fee === undefined) {
        fee = 0;
      } else {
        fee = fee.replace(',', '.');
        fee = parseFloat(fee);
      };
      let sum = parseFloat(netto) + parseFloat(fee);
      sum = sum.toFixed(2);
      sum = sum.replace('.', ',');
      return sum;
    },
    getBrutto(){
      let netto = this.getNetto();
      netto = netto.replace(',', '.');
      let tax = this.getTax();
      tax = tax.replace(',', '.');
      let fee = this.getActivationFee();
      if(fee === undefined) {
        fee = 0;
      } else {
        fee = fee.replace(',', '.');
        fee = parseFloat(fee) * 1.23;
      };
      let price = parseFloat(netto) + parseFloat(tax) + parseFloat(fee);
      price = price.toFixed(2);
      price = price.replace('.', ',');
      return price;
    },
    getActivationFee() {
      let fee;
      if(!this.activationFee) {
        fee = 0;
      } else {
        fee = parseFloat(this.activationFee);
      };
      fee = fee.toFixed(2);
      fee = fee.replace('.', ',');
      return fee;
    },
    getTax(){
      let netto = this.getNetto();
      let price = parseFloat(netto) * 0.23;
      price = price.toFixed(2);
      price = price.replace('.', ',')
      return price;
    },
    getFormData() {
      if(localStorage.formData !== undefined) {
        let formData = JSON.parse(localStorage.formData);
        Object.keys(formData).forEach(key => {
          this.formData[key] = formData[key];
        });
      }
    },
    getStep2State() {
       if(localStorage.step2State !== undefined) {
         const step2State = JSON.parse(localStorage.step2State);
         Object.keys(step2State).forEach(key => {
            if(this[key] == '' || this[key]) {
               this[key] = step2State[key];
            }
         });
      }
    },
    showAgreement(){
      this.$store.commit('toggleAgreement', 1);
      document.body.style = "overflow-y: hidden";
      this.contractSeen = 1;
      if(this.validateContractAgreementCheck.text == this.validateContractAgreementTexts[1]) {
        this.validateContractAgreementCheck.value = 0;
      };
    },
    async order() {
      if(!this.validateCheckbox()) {
        return 0;
      }
      const formData = JSON.parse(localStorage.formData);
      formData.startDate = this.dateStart;
      formData.endDate = this.dateEnd;
      let name;
      if(this.packetActiveReal == 1) {
        name = 'mini';
      } else if(this.packetActiveReal == 2) {
        name = 'standard';
      } else if(this.packetActiveReal == 3) {
        name = 'komfort';
      }
      formData.packet = {
        name: name,
        period: this.getMonthNumber(this.monthActiveReal)
      };
      let self = this;
      await this.axios
      .post(this.api + 'vo/order', formData)
      .then(response => {
        if(response.data.status == 1) {
          // let win = window.open(response.data.href + response.data.token, '_blank');
          // win.focus();
          location.replace(response.data.href + response.data.token);
        } else {
          self.toggleAlert(response.data.status, response.data.msg);
        }
      });
    },
    toggleAlert(type, msg) {
      this.$store.commit('toggleAlert', {
        visibility: 1,
        type: type,
        msg: msg
      });
    },
    validateCheckbox() {
      if(this.contractAgreementCheck == 0) {
        this.validateContractAgreementCheck.value = 1;
        this.validateContractAgreementCheck.text = this.validateContractAgreementTexts[0];
        return 0;
      } else {
        return 1;
      }
    },
  },
  mounted() {
    localStorage.setItem('formStep', 3);
  },
}
</script>

<style scoped lang="scss">
  div.flex { display: flex; justify-content: flex-start; margin: 30px 0; }
  div.column { display: flex; flex-direction: column; }
  div.column:first-child { width: 100%; padding-right: 30px; height: 100%;}
  div.column:nth-child(2) { width: 310px; padding-left: 30px; border-left: 2px solid #f2f2f2; }
  div.column div.sticky-container { height: 100%; display: flex; }
  div.column div.sticky { position: sticky; bottom: 30px; margin-top: auto; }
  div.second-sticky-container { display: none; }

  div.packet.small { width: 250px; height: 450px; }
  div.packet.small div.content { height: 170px; }
  div.packet.small div.content div.icon { display: none; }
  div.packet.small div.content h5 { font-size: 19px; }
  div.packet.small div.content h4 { font-size: 30px; }
  div.packet.small div.content p { font-size: 13px; }

  div.user { width: 250px; display: flex; margin-bottom: 40px; justify-content: center; flex-wrap: wrap; }
  div.user div.icon { display: flex; justify-content: center; align-items: center; width: 60px; height: 60px; border-radius: 50%; border: 2px solid $grayLight; }
  div.user div.icon i.material-icons { font-size: 26px; color: $grayLight; }
  div.user div.user-data { display: flex; flex-direction: column; justify-content: space-around; align-items: center; margin: 5px 0; width: 100%; }
  div.user div.user-data h5 { margin: 0; padding: 0; color: $grayLight; font-weight: 500; font-size: 19px; }
  div.user div.user-data p { text-align: center; margin: 0; padding: 0; color: $orangeDark; font-weight: 500; font-size: 15px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

  div.month { width: 250px; height: 35px; margin: 20px 0; text-align: center; line-height: 35px; color: #fff; font-weight: 300; font-size: 15px;
   background: $grayLight; border-radius: 3px; }
  div.packet.small { margin: 0; }

  div.date { margin: 10px 0; }
  div.date h6 { margin: 0 0 5px 0; padding: 0; color: $grayLight; font-weight: 500; font-size: 14px; text-align: center; }
  div.date p { width: 250px; margin: 0; padding: 5px 20px; background: #f2f2f2; color: $grayDark; font-size: 22px; text-align: center; }

  div.data { width: calc(100% - 40px); max-width: 450px; margin: 15px auto; }
  div.data header h6 { margin: 0; padding: 0 21px; color: $grayLighter; font-weight: 400; font-size: 13px; }
  div.data div.container { padding: 0 15px; border-radius: 5px; background: rgba(228, 228, 230, 1); }
  div.data ul { display: block; width: 100%; margin: 0; padding: 10px 0; list-style: none; border-top: 2px solid rgba(255, 255, 255, 0.2);  }
  div.data ul:first-child { border: 0; }
  div.data ul li { margin: 5px; font-size: 15px; word-wrap: break-word; }
  div.data ul li span { color: $grayLight;  }

  div.prices { display: flex; flex-direction: column; align-items: flex-end; }
  div.price { display: flex; justify-content: space-between; width: 350px; height: 45px; margin: 10px 0; }
  div.price.gray { background: $grayLight; }
  div.price.dark-gray { background: $grayDark; margin-bottom: 0; }
  div.price h5 { margin: auto 10px; padding: 0; font-weight: 300; font-size: 14px; color: #fff; margin-right: 0; max-width: 122px; }
  div.price h6 { margin: auto 13px; padding: 0; font-weight: 300; font-size: 19px; color: #fff; min-width: 77px; }
  div.price.dark-gray h6 { font-size: 19px; font-weight: 500; }

  div.price { width: 250px; }
  div.price h6 { font-size: 18px; }
  div.price.orange h6 { font-size: 22px; }

  div.button { display: flex; justify-content: flex-end; }
  button.default.small { margin-left: auto; }
  
  div.container li p { font-size: 13px; color: $grayLight; display: flex; align-items: center; }
  div.container li:nth-child(5) p { align-items: flex-start }
  div.container li p span { margin-top: -2px; }
  div.container li p i { margin-right: 7px; font-size: 17px; }

  div.input-container { display: flex; flex-direction: column; align-items: flex-end; margin-top: 10px; }
  div.input-container p.checkbox { padding: 0 0 0 28px; }
  div.input-container div.input-checkbox { display: flex; height: inherit; }
  div.input-container div.input-checkbox div.checkbox { margin-top: 2px; flex-shrink: 0; }
  div.input-container div.input-checkbox div.checkbox.error { border-color: #F44336; }
  div.input-container div.input-checkbox p { margin: 0 0 0 10px; padding: 0; font-size: 13px; color: $fontBlack; }
  div.input-container div.input-checkbox p a {color: $orangeLight; }

  div.warning {
    background-color: $red;
    margin: 10px auto;
    padding: 10px;
    border-radius: 4px;
    width: 450px;
  }
  div.warning h4 {
    margin: 0;
    padding: 0;
    font-weight: 500;
    font-size: 14px;
    color: #fff;
  }
  div.warning p {
    margin: 0;
    padding: 0;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.9);
  }
  div.warning p span {
    font-weight: 700;
    font-size: 14px;
    color: #fff;
  }

  @media (max-width: 700px) {
    div.flex { flex-direction: column-reverse; }
    div.column { margin: 0 auto; }
    div.column:first-child { padding-right: 0; }
    div.column:nth-child(2) { width: calc(100% - 40px); max-width: 450px; margin-bottom: 30px; border-left: none; align-items: center; padding: 0; }
    div.second-sticky-container { display: flex; justify-content: center; margin-bottom: 30px; }
    div.sticky-container { width: 100% }
    div.sticky-container div.sticky { width: 100% }
    div.second-sticky-container div.sticky { width: calc(100% - 40px); max-width: 450px; }
    div.price { width: 100%; }
    div.date p { width: 100%; }
  }

  @media (max-width: 360px) {
    div.wrapper { font-size: 60%; }
    div.content { padding: 10px 10px !important; }
    div.month { width: 100%; }
    div.packet.standard.small { width: 100% }
    div.data ul li { font-size: 100%; }
    div.container li p { font-size: 100%; }
    div.data header h6 { font-size: 100%; }
  }
</style>
